import { ProfileStore } from '~/stores/profile'
import { normalizePhone } from '~/utils/format'

export class OutboundLead {
  static use() {
    const profile = ProfileStore.use()

    const { track } = Analytics.use()

    const { createOutboundContactClient } = PxApi.use()

    const skipContactEntry = computed(() => !_isNil(profile.primaryContactPhone?.number))

    const hasOutboundLead = (phone: string) => profile.hasExt('outbound_lead_phone', phone)

    async function sendOutboundRequest(
      email: string,
      phone: string,
      origin?: string | null,
      contactPreference?: string,
      force?: boolean,
      schedule?: { time?: string; timeZone?: string; notes?: string | null }
    ) {
      const outboundClient = createOutboundContactClient()
      try {
        await outboundClient.saveCallRequest({
          profileId: profile.id!,
          firstName: profile.firstName!,
          lastName: profile.lastName!,
          email: email,
          phone: phone,
          force: force,
          origin,
          contactPreference,
          time: schedule?.time,
          timeZone: schedule?.timeZone,
          notes: schedule?.notes
        })

        await profile.load()

        track('OutboundCallRequested')
      } catch (error) {
        console.error(error)
      }
    }

    return {
      skipContactEntry,
      hasOutboundLead,
      sendOutboundRequest
    }
  }
}
